import { z } from 'zod'

/**
 * The single file allowed to import zod, alongside the runner that consumes
 * these schemas. Everything else in the app sees ValidationResult.
 *
 * Schemas carry a *label key* per field rather than a label: the field name
 * appears in the message ("Email is required"), so it is copy and follows §U.
 * zod's `.meta()` is the supported way to attach that without a parallel map.
 */
export const field = <T extends z.ZodType>(schema: T, labelKey: string): T => schema.meta({ labelKey }) as T

export const labelKeyOf = (schema: z.ZodType | undefined): string | null => {
  const meta = schema?.meta() as { labelKey?: string } | undefined
  return meta?.labelKey ?? null
}

export { z }
export type Schema<T> = z.ZodType<T>
